import React from "react";
import ReactTable from "react-table";
import { Button } from "reactstrap";
import axiosInstance from "../../axios-project";
class ContactTable extends React.Component {
  render() {
    let contacts = this.props.contacts;
    const columns = [
      {
        Header: "Title",
        accessor: "contact_title",
        maxWidth: 95
      },
      { Header: "Name", accessor: "contact_name" },
      { Header: "Email", accessor: "contact_email" },
      { Header: "Phone", accessor: "contact_phone" },
      {
        Header: "Action",
        sortable: false,
        Cell: props => (
          <div style={{ textAlign: "center" }}>
            <Button size="sm" className="btn-danger mx-1">
              Delete
            </Button>
          </div>
        ),
        maxWidth: 95
      },
      { Header: "", accessor: "contact_id", show: false },
      { Header: "", accessor: "organization_id", show: false }
    ];
    let filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      return row[id]
        ? String(row[id])
            .toLowerCase()
            .startsWith(filter.value.toLowerCase())
        : false;
    };
    columns.forEach(h => (h.headerStyle = { fontWeight: "bold" }));
    return (
      <ReactTable
        defaultFilterMethod={filterCaseInsensitive}
        filterable
        defaultPageSize={10}
        className="-highlight -striped"
        data={contacts}
        columns={columns}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (column.Header === "Action") {
                if (window.confirm("Please confirm deletion.")) {
                  axiosInstance
                    .delete("/contact/" + rowInfo.row.contact_id)
                    .then(
                      setTimeout(
                        () =>
                          this.props.fetchContacts(rowInfo.row.organization_id),
                        1000
                      )
                    );
                }
              } else {
                this.props.modifyContactClicked(
                  rowInfo ? rowInfo.row.contact_id : 0
                );
              }
            }
          };
        }}
      />
    );
  }
}
export default ContactTable;
